import React from 'react';
import { Link } from 'react-router-dom';
import { NavBurgerSvg } from '../../icons';
import { MainpageComponentContainer } from '../../styles/styled';
import useWindowDimensions from '../../utils/getScreenHeight';
import { NeutralNavigationUI } from './styled';

export const NeutralNavbarComponent = () => {
  const { width } = useWindowDimensions();

  return width > 875 ? (
    <NeutralNavigationUI>
      <MainpageComponentContainer direction="row" justify="space-between">
        <div className="item">
          <NavBurgerSvg />
          <Link to="/">
            <div className="layout big">ФЕДЕРАЛЬНЫЙ ПЕРЕЧЕНЬ УЧЕБНИКОВ</div>
          </Link>
        </div>
        <a href="https://edu.gov.ru/" rel="noreferrer" target="_blank">
          <div className="item">
            <img src="/gerb.png" alt="gerb" />
            <div className="layout small">МИНИСТЕРСТВО ПРОСВЕЩЕНИЯ РОССИЙСКОЙ ФЕДЕРАЦИИ</div>
          </div>
        </a>
      </MainpageComponentContainer>
    </NeutralNavigationUI>
  ) : (
    <></>
  );
};
